<template>
    <div>
        <!-- Header -->
        <div class="flex justify-center card-header py-2">
            <h3 id="popups.title.list">{{ translate('Popups') }}</h3>
        </div>

        <!-- Table -->
        <BaseTable v-if="!isRetrievingPopups && popups.length" :items="popups" :columns="columns" title="Popups">
            <template #table-header-action>
                <div class="w-full flex justify-end mx-3">
                    <BaseButton id="popups.button.addpopup" type="submit" class="btn btn-twitter" @click="onAddPopup">
                        <span class="btn-inner--icon"><i class="ni ni-fat-add"></i></span>
                        {{ translate('New Popup') }}
                    </BaseButton>
                </div>
            </template>

            <template #actions="{ item }">
                <div class="flex items-center gap-x-2">
                    <BaseButton id="popups.button.editpopup" :customClass="'rounded-circle border-none bg-blue-400 px-2 h-8 w-8'"
                        @click="onEditPopup(item.id)">
                        <el-tooltip :content="translate('Edit')" placement="top">
                            <i class="far fa-edit text-white text-xs"></i>
                        </el-tooltip>
                    </BaseButton>

                    <BaseButton id="popups.button.deletepopup" :customClass="'rounded-circle border-none bg-red-500 px-2 h-8 w-8'"
                        @click="removePopup(item.id)">
                        <el-tooltip :content="translate('Delete')" placement="top">
                            <i aria-hidden="true" class="fa fa-trash text-white text-xs"></i>
                        </el-tooltip>
                    </BaseButton>
                </div>
            </template>
        </BaseTable>

        <!-- Loading State -->
        <div v-if="isRetrievingPopups" class="p-4 text-center h-96 grid place-items-center">
            <div class="text-center">
                <i class="fas fa-spinner fa-spin text-3xl"></i>
            </div>
        </div>

        <!-- No Data -->
        <div v-if="!isRetrievingPopups && !popups.length" class="p-4 text-center h-96 grid place-items-center">
            <div>
                <div class="mb-2">
                    <i class="fas fa-ban text-2xl"></i>
                    <p class="mt-2">{{ translate('No Data Available') }}</p>
                </div>
                <BaseButton id="popups.button.addpopup" type="submit" class="btn btn-twitter" @click="onAddPopup">
                    <span class="btn-inner--icon"><i class="ni ni-fat-add"></i></span>
                    {{ translate('Add Popup') }}
                </BaseButton>
            </div>
        </div>
    </div>
</template>


<script>
import { eventHandler, translations } from '@/mixins'
import BaseTable from '@/components/Table/BaseTable.vue';
import BaseButton from '@/components/Buttons/BaseButton.vue';
import { Popup as PopupApi } from "@/services/SOLO"

export default {
    name: 'PopUps',
    mixins: [eventHandler, translations],
    components: {
        BaseTable,
        BaseButton
    },
    data() {
        return {
            popups: [],
            columns: [
                { label: 'Name', key: 'label', id: 'popups.column.label' },
                { label: 'Image', key: 'image-uri', id: 'popups.column.image' },
                { label: 'Button Name', key: 'button-label', id: 'popups.column.buttonlabel' },
                { label: 'Idle Time(s)', key: 'idle-seconds', id: 'popups.column.idleseconds' },
            ],
            isRetrievingPopups: true,
        }
    },
    computed: {
        buttonClasses() {
            const base = 'inline-flex items-center justify-center font-medium rounded focus:outline-none focus:ring transition';

            const variants = {
                primary: 'bg-blue-600 text-white hover:bg-blue-700',
                secondary: 'bg-gray-200 text-gray-800 hover:bg-gray-300',
                danger: 'bg-red-600 text-white hover:bg-red-700',
            };

            const sizes = {
                sm: 'text-sm px-3 py-1.5',
                md: 'text-base px-4 py-2',
                lg: 'text-lg px-5 py-3',
            };

            const disabledClass = this.disabled
                ? 'opacity-50 cursor-not-allowed'
                : '';

            return [base, variants[this.variant], sizes[this.size], disabledClass].join(' ');
        },
    },
    mounted() {
        this.getPopups()
    },
    methods: {
        async getPopups() {
            try {
                this.isRetrievingPopups = true;
                const popups = await PopupApi.all()
                this.popups = popups.data.data
            } catch (error) {
                this.$notify({
                    title: "ERROR FETCHING POPUPS!",
                    verticalAlign: "bottom",
                    horizontalAlign: "left",
                    message: "Something went wrong, please try again!",
                    type: "danger",
                    icon: "fas fa-bomb",
                });
            } finally {
                this.isRetrievingPopups = false;
            }
        },
        onEditPopup(popupId) {
            this.$router.push({ name: 'edit-popup', params: { popupId } });
        },
        async removePopup(popupId) {
            const confirmed = await this.confirm(this.$bvModal, 'Are you sure you want to delete this popup?');
            if (!confirmed) return;
            try {
                await PopupApi.removePopup(popupId);

                this.getPopups();
                this.$notify({
                    title: "POPUP DELETED!",
                    verticalAlign: "bottom",
                    horizontalAlign: "left",
                    message: "Popup has been deleted successfully",
                    type: "success",
                    icon: "fas fa-check",
                });

            } catch (err) {
                this.$notify({
                    title: "ERROR DELETING POPUP!",
                    verticalAlign: "bottom",
                    horizontalAlign: "left",
                    message: "Something went wrong, please try again!",
                    type: "danger",
                    icon: "fas fa-bomb",
                });
            }
        },
        onAddPopup() {
            this.$router.push({ name: 'create-popup' });
        }
    }
}
</script>
